export default __webpack_public_path__ + "static/media/3q_b.09975b4e.png";